import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Table,
  TableCell,
  TableRow,
  TableBody,
} from "@mui/material";
import { useState } from "react";
import { getContact } from "../services/contactService";
import {
  searchProperties,
  updatePropertyContact,
} from "../services/propertyService";
import Contacts from "./contacts";
import {
  resetContacts,
  setResults,
  setSearchTerm,
  setSelectedContact,
  setSelectedContacts,
  setTempData,
} from "../features/contactSlice";
import { useDispatch, useSelector } from "react-redux";
import { setContact, setContacts } from "../features/assessorSlice";

const Properties = () => {
  const [filter, setFilter] = useState(1);
  const [data, setData] = useState("");
  const [selected, setSelected] = useState(null);
  const [properties, setProperties] = useState();
  const contactInfo = useSelector((state) => state.contact.value);
  const [touched, setTouched] = useState("");
  const dispatch = useDispatch();

  const contactSelectionKey = (ids = []) =>
    [...(ids || [])].sort((a, b) => a - b).join(",");

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      spacing={2}
      sx={{ p: { xs: 1, md: 2 } }}
    >
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Stack spacing={0.5} textAlign="left">
              <Typography variant="h5">Property Search</Typography>
              <Typography variant="body2" color="text.secondary">
                Find any property by parcel ID or address and manage its
                contacts.
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={2}>
        <FormControl fullWidth>
          <InputLabel>Search By</InputLabel>
          <Select
            label="Search By"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value={1}>Parcel ID</MenuItem>
            <MenuItem value={2}>Address</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <TextField
          onChange={async (e) => {
            searchProperties(
              e.target.value.trim(),
              filter === 1 ? "parcelID" : "address"
            ).then((r) => {
              setProperties(r);
            });
            setData(e.target.value);
            dispatch(resetContacts());
            dispatch(setContacts([]));
            setSelected(null);
            setTouched("");
          }}
          value={data}
          label={filter === 1 ? "Enter Parcel ID" : "Enter Address"}
          fullWidth
        />
      </Grid>
      {properties ? (
        properties.slice(0, 20).map((p, i) => {
          return (
            <Grid key={i} item xs={9}>
              <Card>
                <CardHeader
                  title={
                    <>
                      <Checkbox
                        checked={selected === p.id}
                        onChange={async () => {
                          dispatch(resetContacts());
                          dispatch(setContacts([]));
                          if (selected === p.id) {
                            setSelected(null);
                          } else {
                            const contactIds = Array.isArray(p.contact_ids)
                              ? p.contact_ids
                              : p.contact_id
                                ? [p.contact_id]
                                : [];

                            const contactRows = (
                              await Promise.all(
                                contactIds.map((contactId) => getContact(contactId))
                              )
                            ).filter(Boolean);

                            if (contactRows.length) {
                              dispatch(setSearchTerm(contactRows[0].name || ""));
                              dispatch(setResults(contactRows));
                              dispatch(setSelectedContact(contactRows[0].id));
                              dispatch(setSelectedContacts(contactIds));
                              dispatch(setTempData(contactRows[0]));
                              dispatch(setContacts(contactIds));
                              dispatch(setContact(contactIds[0] || null));
                            } else {
                              dispatch(resetContacts());
                              dispatch(setContacts([]));
                            }
                            setTouched(contactSelectionKey(contactIds));
                            setSelected(p.id);
                          }
                        }}
                      />
                      {p.parcelID}
                    </>
                  }
                />
                <CardContent>
                  <Table sx={{ mb: 3 }}>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">Owner Name</TableCell>
                        <TableCell align="center">{p.owner_name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Owner Mailing</TableCell>
                        <TableCell align="center">{p.owner_mailing}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Building Address</TableCell>
                        <TableCell align="center">
                          {p.building_address}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Assessed Value</TableCell>
                        <TableCell align="center">
                          ${p.assessor_value}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">CID Value</TableCell>
                        <TableCell align="center">${p.cid_value}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  {selected !== p.id ? (
                    <></>
                  ) : (
                    <>
                      <Contacts mode="embedded" />
                      <Button
                        variant="contained"
                        disabled={
                          contactSelectionKey(contactInfo.selectedContacts) === touched
                        }
                        onClick={() => {
                          updatePropertyContact(
                            selected,
                            contactInfo.selectedContacts
                          );
                          setTouched(contactSelectionKey(contactInfo.selectedContacts));
                          
                        }}
                      >
                        Update Property Data
                      </Button>
                    </>
                  )}
                </CardContent>
              </Card>
              <br />
            </Grid>
          );
        })
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default Properties;
